import { CodeBase } from "./_codeBase";

/** 処理区分*/
export class ProcessDiv extends CodeBase<ProcessDiv>
{
    /** 処理区分: "00", "未更新"*/
    public static readonly UNDONE: ProcessDiv = new ProcessDiv("00", "未更新", "");
    /** 処理区分: "01", "更新済み"*/
    public static readonly DONE: ProcessDiv = new ProcessDiv("01", "更新済み", "");

    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): ProcessDiv[] {
        return [
            ProcessDiv.UNDONE,
            ProcessDiv.DONE,
        ];
    }
}
